// Helper function to format values
export const formatValue = (value: any): string => {
    if (typeof value === "boolean") return value ? "Yes" : "No"
    if (value === null || value === undefined) return "N/A"
    return String(value)
}